import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ComputationReferenceInterface} from "../../interfaces/computation/computation-reference.interface";
import {HelperService} from "../../services/helpers/helper.service";
import {ModalHeaderComponent} from '../../layout/modal-header/modal-header.component';
import {NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {PrettyPrintJsonComponent} from '../../components/pretty-print-json/pretty-print-json.component';

@Component({
    selector: 'app-computation-example',
    templateUrl: './computation-example.component.html',
    styleUrls: ['./computation-example.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent, NgSwitch, NgSwitchCase, PrettyPrintJsonComponent, NgSwitchDefault]
})
export class ComputationExampleComponent implements OnInit {
  itemInList = [
    {
      datapoint: 'Image',
      url: 'Whatever image url'
    }, {
      datapoint: 'linkedin',
      url: 'linkedin.com/in/onion-os'
    }, {
      datapoint: 'website',
      url: 'onionos.io'
    }
  ]
  list = [
    {
      listId: 1574,
      timestamp: 16550,
      active: true
    },
    {
      listId: 504,
      timestamp: 1300,
      active: true
    },
    {
      listId: 1440,
      timestamp: 17400,
      active: true
    },
    {
      listId: 354,
      timestamp: 14550,
      active: true
    }
  ]
  object = {
    user: {
      name: {
        first: 'John',
        last: 'Doe'
      },
      email: 'john@onionos.io'
    }
  }
  list2 = ['Facebook', 'Amazon', 'Apple', 'Netflix', 'Google']
  executionId = this.helperSvc.generateId(25)
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      computation: ComputationReferenceInterface,
    },
    public dialogRef: MatDialogRef<ComputationExampleComponent>,
    private helperSvc: HelperService
  ) { }

  ngOnInit(): void {
  }

}
